import { IGlobalLoader, TToggleGlobalLoaingAction } from '../../types/redux/app';

export const TOGGLE_GLOBAL_LOADING = 'TOGGLE_GLOBAL_LOADING';

export const toggleGlobalLoading = ({ loading, title }: IGlobalLoader): TToggleGlobalLoaingAction => ({
    type: TOGGLE_GLOBAL_LOADING,
    payload: {
        loading,
        title,
    },
});
